import { Box, Button, Card, CardBody, Heading, Text } from "@chakra-ui/react"
import Image from "next/image"
import Link from "next/link"

export interface DashboardTeaserProps {
  backgroundImage: string
  title: string
  link: string
}1

export const DashboardTeaser = ({ backgroundImage, title, link }: DashboardTeaserProps) => {
  return (
    <Card backgroundColor="#5188EC" overflow="hidden" height={265}>
      <CardBody display="flex" overflow="hidden" background={`url(${backgroundImage}) no-repeat center center`} backgroundSize="cover">
        <Box flexBasis="50%" display="flex" justifyContent="space-between" flexDirection="column" position="relative" >
          <Heading size="sm"><Text color="text.lightMode.white">{title}</Text></Heading>
          <Link href={link} target="_blank">
            <Button
              variant="primary"
            >
              See more
            </Button>
          </Link>
        </Box>
      </CardBody>
    </Card>
  )
}